import ClosetObject from './ClosetObject';
import { ltjsModule } from './ltjsEnvironment';
import { getWrapper, getWrapperArray } from './WrappableCloset';
export var TypeValue = {
    VOID: 0,
    WRAPPER: 1,
    BOOLEAN: 2,
    UNSIGNED: 3,
    INT: 4,
    FLOAT: 5,
    DOUBLE: 6,
    STRING: 7,
    SASDATE: 8,
    SASDATETIME: 9,
    SASCOLOR: 10,
    POINT: 11,
    RECTANGLE: 12,
    SIZE: 13,
};
export function convertFromJni(type, isProperty) {
    if (isProperty === void 0) { isProperty = false; }
    if (Array.isArray(type)) {
        if (isProperty) {
            return convertVectorPropertyFromJni[type[0]];
        }
        else {
            return convertVectorFromJni[type[0]];
        }
    }
    else {
        return convertScalarFromJni[type];
    }
}
export function convertToJni(type) {
    if (Array.isArray(type)) {
        return convertVectorToJni[type[0]];
    }
    else {
        return convertScalarToJni[type];
    }
}
var releasePrimitive = ltjsModule.releasePrimitive.bind(ltjsModule);
var releaseAllPrimitives = ltjsModule.releaseAllPrimitives.bind(ltjsModule);
var identityConverter = { convert: function (value) { return value; } };
var booleanConverter = { convert: function (value) { return !!value; } };
var shiftConverter = { convert: function (value) { return value >>> 0; } };
var stringFromCConverter = {
    convert: ltjsModule.convertStringFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var floatArrayFromCConverter = {
    convert: ltjsModule.convertFloatArrayFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var boolArrayFromCConverter = {
    convert: ltjsModule.convertBoolArrayFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var unsignedArrayFromCConverter = {
    convert: ltjsModule.convertUnsignedArrayFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var intArrayFromCConverter = { convert: ltjsModule.convertIntArrayFromC.bind(ltjsModule), cleanup: releasePrimitive };
var doubleArrayFromCConverter = {
    convert: ltjsModule.convertDoubleArrayFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var stringArrayFromCConverter = { convert: ltjsModule.convertStringArrayFromC.bind(ltjsModule) };
var geometryArrayFromCConverter = { convert: ltjsModule.convertGeometryArrayFromC.bind(ltjsModule) };
var boolMVectorFromCConverter = {
    convert: ltjsModule.convertBoolMVectorFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var unsignedMVectorFromCConverter = {
    convert: ltjsModule.convertUnsignedMVectorFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var intMVectorFromCConverter = {
    convert: ltjsModule.convertIntMVectorFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var floatMVectorFromCConverter = {
    convert: ltjsModule.convertFloatMVectorFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var doubleMVectorFromCConverter = {
    convert: ltjsModule.convertDoubleMVectorFromC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var stringToCConverter = { convert: ltjsModule.convertStringToC.bind(ltjsModule), cleanup: releasePrimitive };
var floatArrayToCConverter = { convert: ltjsModule.convertFloatArrayToC.bind(ltjsModule), cleanup: releasePrimitive };
var objectArrayToCConverter = {
    convert: ltjsModule.convertObjectArrayToC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var boolArrayToCConverter = { convert: ltjsModule.convertBoolArrayToC.bind(ltjsModule), cleanup: releasePrimitive };
var unsignedArrayToCConverter = {
    convert: ltjsModule.convertUnsignedArrayToC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var intArrayToCConverter = { convert: ltjsModule.convertIntArrayToC.bind(ltjsModule), cleanup: releasePrimitive };
var doubleArrayToCConverter = {
    convert: ltjsModule.convertDoubleArrayToC.bind(ltjsModule),
    cleanup: releasePrimitive,
};
var stringArrayToCConverter = {
    convert: ltjsModule.convertStringArrayToC.bind(ltjsModule),
    cleanup: releaseAllPrimitives,
};
var geometryArrayToCConverter = {
    convert: ltjsModule.convertGeometryArrayToC.bind(ltjsModule),
    cleanup: releaseAllPrimitives,
};
var convertScalarFromJni = [];
convertScalarFromJni[TypeValue.VOID] = identityConverter;
convertScalarFromJni[TypeValue.WRAPPER] = { convert: getWrapper };
convertScalarFromJni[TypeValue.BOOLEAN] = booleanConverter;
convertScalarFromJni[TypeValue.UNSIGNED] = shiftConverter;
convertScalarFromJni[TypeValue.INT] = identityConverter;
convertScalarFromJni[TypeValue.FLOAT] = identityConverter;
convertScalarFromJni[TypeValue.DOUBLE] = identityConverter;
convertScalarFromJni[TypeValue.STRING] = stringFromCConverter;
convertScalarFromJni[TypeValue.SASDATE] = identityConverter;
convertScalarFromJni[TypeValue.SASDATETIME] = identityConverter;
convertScalarFromJni[TypeValue.SASCOLOR] = shiftConverter;
convertScalarFromJni[TypeValue.POINT] = floatArrayFromCConverter;
convertScalarFromJni[TypeValue.RECTANGLE] = floatArrayFromCConverter;
convertScalarFromJni[TypeValue.SIZE] = floatArrayFromCConverter;
var convertVectorFromJni = [];
// TypeValue.VOID vector not supported
convertVectorFromJni[TypeValue.WRAPPER] = { convert: getWrapperArray };
convertVectorFromJni[TypeValue.BOOLEAN] = boolArrayFromCConverter;
convertVectorFromJni[TypeValue.UNSIGNED] = unsignedArrayFromCConverter;
convertVectorFromJni[TypeValue.INT] = intArrayFromCConverter;
convertVectorFromJni[TypeValue.FLOAT] = floatArrayFromCConverter;
convertVectorFromJni[TypeValue.DOUBLE] = doubleArrayFromCConverter;
convertVectorFromJni[TypeValue.STRING] = stringArrayFromCConverter;
convertVectorFromJni[TypeValue.SASDATE] = doubleArrayFromCConverter;
convertVectorFromJni[TypeValue.SASDATETIME] = doubleArrayFromCConverter;
convertVectorFromJni[TypeValue.SASCOLOR] = unsignedArrayFromCConverter;
convertVectorFromJni[TypeValue.POINT] = geometryArrayFromCConverter;
convertVectorFromJni[TypeValue.RECTANGLE] = geometryArrayFromCConverter;
convertVectorFromJni[TypeValue.SIZE] = geometryArrayFromCConverter;
var convertVectorPropertyFromJni = [];
// TypeValue.VOID property vector not supported
convertVectorPropertyFromJni[TypeValue.WRAPPER] = { convert: getWrapperArray };
convertVectorPropertyFromJni[TypeValue.BOOLEAN] = boolMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.UNSIGNED] = unsignedMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.INT] = intMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.FLOAT] = floatMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.DOUBLE] = doubleMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.STRING] = stringArrayFromCConverter;
convertVectorPropertyFromJni[TypeValue.SASDATE] = doubleMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.SASDATETIME] = doubleMVectorFromCConverter;
convertVectorPropertyFromJni[TypeValue.SASCOLOR] = unsignedMVectorFromCConverter;
// TypeValue.POINT property vector not supported
// TypeValue.RECTANGLE property vector not supported
// TypeValue.SIZE property vector not supported
var convertScalarToJni = [];
// TypeValue.VOID argument type unsupported
convertScalarToJni[TypeValue.WRAPPER] = { convert: ClosetObject._getValidClosetAddress };
convertScalarToJni[TypeValue.BOOLEAN] = booleanConverter;
convertScalarToJni[TypeValue.UNSIGNED] = identityConverter;
convertScalarToJni[TypeValue.INT] = identityConverter;
convertScalarToJni[TypeValue.FLOAT] = identityConverter;
convertScalarToJni[TypeValue.DOUBLE] = identityConverter;
convertScalarToJni[TypeValue.STRING] = stringToCConverter;
convertScalarToJni[TypeValue.SASDATE] = identityConverter;
convertScalarToJni[TypeValue.SASDATETIME] = identityConverter;
convertScalarToJni[TypeValue.SASCOLOR] = identityConverter;
convertScalarToJni[TypeValue.POINT] = floatArrayToCConverter;
convertScalarToJni[TypeValue.RECTANGLE] = floatArrayToCConverter;
convertScalarToJni[TypeValue.SIZE] = floatArrayToCConverter;
var convertVectorToJni = [];
// TypeValue.VOID[] argument type not supported
convertVectorToJni[TypeValue.WRAPPER] = objectArrayToCConverter;
convertVectorToJni[TypeValue.BOOLEAN] = boolArrayToCConverter;
convertVectorToJni[TypeValue.UNSIGNED] = unsignedArrayToCConverter;
convertVectorToJni[TypeValue.INT] = intArrayToCConverter;
convertVectorToJni[TypeValue.FLOAT] = floatArrayToCConverter;
convertVectorToJni[TypeValue.DOUBLE] = doubleArrayToCConverter;
convertVectorToJni[TypeValue.STRING] = stringArrayToCConverter;
convertVectorToJni[TypeValue.SASDATE] = doubleArrayToCConverter;
convertVectorToJni[TypeValue.SASDATETIME] = doubleArrayToCConverter;
convertVectorToJni[TypeValue.SASCOLOR] = unsignedArrayToCConverter;
convertVectorToJni[TypeValue.POINT] = geometryArrayToCConverter;
convertVectorToJni[TypeValue.RECTANGLE] = geometryArrayToCConverter;
convertVectorToJni[TypeValue.SIZE] = geometryArrayToCConverter;
